import React from 'react';
import { useNavigate, useParams } from 'react-router';

import { BackButton, Loading, NOTIFICATION_TYPE, Notification } from 'components';
import { ExporterForm } from 'features/sellers/components/form/ExporterForm';
import { useGetExporter } from 'features/sellers/hooks/useGetExporter';

export function EditExporter() {
  const { id } = useParams();
  const { data: exporter, isFetching, isLoading, error } = useGetExporter(id);

  const navigate = useNavigate();

  const onSuccess = () => {
    Notification(NOTIFICATION_TYPE.SUCCESS, 'Exporter was updated successfully');
    navigate(-1);
  };

  const onError = (error) => {
    Notification(NOTIFICATION_TYPE.DANGER, error.message);
  };

  if (isFetching || isLoading) {
    return <Loading />;
  }

  if (error) {
    return <p>{error.message}</p>;
  }

  return (
    <div>
      <div className="mb-4">
        <BackButton />
      </div>

      <div className="row mb-4">
        <h1>Edit Seller</h1>
      </div>

      <ExporterForm
        action="edit"
        initialValues={exporter}
        onSuccess={onSuccess}
        onError={onError}
      />
    </div>
  );
}
